/** Whether this storage supports subscriptions. */
export function isStorageWithSubscription(storage) {
    return 'subscribe' in storage;
}
